// P12 apps
export const P12_APPS = {
  STUDY: {
    id: 'study',
    title: 'Study',
    iconClass: 'study',
    urls: {
      local: 'http://localhost:5030',
      dev: 'https://study.dev.gridunity.net',
      test: 'https://study.test.gridunity.net',
      uat: 'https://study.uat.gridunity.net',
      prod: 'https://study.gridunity.net',
    },
  },
  AUDIT: {
    id: 'audit',
    title: 'Audit Console',
    iconClass: 'audit',
    urls: {
      local: 'http://localhost:5140',
      dev: 'https://audit.dev.gridunity.net',
      test: 'https://audit.test.gridunity.net',
      uat: 'https://audit.uat.gridunity.net',
      prod: 'https://audit.gridunity.net',
    },
  },
}

// helper function to return a P12 app url based on the current context
export function getP12Url (app) {
  const availableApps = Object.keys(P12_APPS)
  if (!app || !availableApps.includes(app.toUpperCase())) {
    console.warn('Cannot find P12 app ', app.toUpperCase())
    return
  }

  const context = window.siteVars?.env?.context

  const appUrls = P12_APPS[app.toUpperCase()].urls || {}
  const availableAppUrls = Object.keys(appUrls)
  if (!context || !availableAppUrls.includes(context)) {
    console.warn('Cannot find context ', context, ' for P12 app ', app.toUpperCase())
    return
  }

  return appUrls[context]
}

// replace the P12:APP placeholder with the actual P12 app url
export function replaceP12Placeholder (url) {
  if (!url || !url.startsWith('P12:')) return url

  const [, app] = url.split(':')
  const appUrl = getP12Url(app)
  return appUrl || url
}
